customElements.whenDefined("shopify-forms-embed").then(() => {
  document.querySelectorAll("shopify-forms-embed").forEach(applyStyles);

  // Watch for embeds added later (e.g. multiple blocks rendering asynchronously)
  const observer = new MutationObserver(() => {
    document.querySelectorAll("shopify-forms-embed").forEach(applyStyles);
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

function applyStyles(host) {
  if (!host.shadowRoot || host.dataset.stylesApplied) return;
  host.dataset.stylesApplied = "true";

  // Walk up to the flex container, stretching each wrapper.
  let el = host;
  while (el && !el.classList.contains("group-block-content")) {
    const parent = el.parentElement;
    if (parent && parent.classList.contains("group-block-content")) {
      el.style.alignSelf = "stretch";
    } else {
      el.style.width = "100%";
    }
    el = parent;
  }

  // Inject custom styles into the open shadow root
  const style = document.createElement("style");
  style.textContent = `
    :host {
      --inline-container-max-width: 100%;
      --container-max-w: 100%;
      --inline-form-alignment: left;
      --button-border-radius: 20px;
      --form-field-border-radius: 20px;
      --button-padding: 12px 30px;
      --forms-body-font: normal 400 14px Inter, sans-serif;
      --form-field-border-focused: var(--form-field-border);
    }

    #app-embed form { gap: 25px; }
    #app-embed button[type="submit"] { align-self: center; font-weight: 600; }
    section[class^='_formContainer'] { margin: 0; }
    [class^='_formFieldContainer_']:has(textarea)::before { content: none !important; }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
      box-shadow: 0 0 0px 1000px var(--color-background) inset, var(--form-field-border) !important;
      -webkit-text-fill-color: var(--color-foreground) !important;
      transition: background-color 5000s ease-in-out 0s;
    } 
  `;
  host.shadowRoot.appendChild(style);
}
